<!--
 * @Description: 反馈详情
 * @Author: fely
 * @Date: 2020-06-12 14:53:41
 * @LastEditTime: 2020-08-22 17:04:45
 * @LastEditors: fely
--> 
<template>
  <div class="feedback-info">
    <div class="top-menu">
      <span>反馈详情</span>
      <span class="el-icon-close" @click="closeMask"></span>
    </div>
    <div class="content">
      <el-timeline :reverse="reverse">
        <el-timeline-item
          placement="bottom"
          v-for="(activity, index) in feedlist"
          :key="index"
          color="#4E90FF"
          >
          <p>提交时间：{{activity.createtime}}</p>
          <p class="context">反馈内容：{{activity.content}}</p>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      reverse: true,
    }
  },
  props:{
    feedlist: {
      type: Array,
      default(){
        return []
      }
    }
  },
  methods: {
    closeMask(){
      this.$emit('closeMask')
    },
  },
}
</script>

<style scoped lang="less">
.feedback-info{
  background-color: #fff;
  width: 320px;
  height: 426px;
  display: flex;
  flex-direction: column;
  .top-menu{
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px 12px 14px;
    cursor: pointer;
  }
  .content{
    
    padding-left: 15px;
    .context{
      margin-top: 10px;
    }
  }

  /deep/ .el-timeline{
    color: #666666 !important;
  }


  /deep/ .el-timeline-item__node--normal{
    width: 7px;
    height: 7px;
  }
}
</style>
